import React from "react";
import "../styles/Products.css";
import { useLanguage } from "../contexts/LanguageContext";

const pdfList = [
  { name: "Erişim Talep Formu", file: "erisim_talep_formu.pdf" },
  { name: "Has Gümüş Değerli Madenler Müşteri Tanıtma Formu", file: "tani_formu.pdf" },
  { name: "Has Gümüş Değerli Madenler Çerçeve Sözleşmesi", file: "cercevesoz.pdf" },
  { name: "Has Gümüş Değerli Madenler Aydınlatma Metni", file: "aydinlatma_metni.pdf" },
  { name: "Ek Beyan -1", file: "ek-1-Beyan.pdf" },
  { name: "Suç Gelirlerinin Aklanması Ve Terörün Finansmanının Önlenmesi Hakkında Şirket Politikası Ve Uygulama Esasları", file: "masak.pdf" },
  { name: "Rüşvet Ve Yolsuzlukla Karşı Politika", file: "rusvetVeyolsuzluk.pdf" },
  { name: "Has Gümüş Değerli Madenler. A.Ş Müşteri Kabul Politikası", file: "musterikabul.pdf" },
  { name: "Has Gümüş Değerli Madenler Çerez Aydınlatma Metni", file: "cerez.pdf" },
  { name: "Has Gümüş Değerli Madenler 2018 Raporu", file: "hasgumus_ikibinonsekizrapor.pdf" },
  { name: "Has Gümüş Rapor 2019(imzalı)", file: "imzali_iki_bin_ondokuz.pdf" },
  { name: "Has Gümüş Değerli Madenler 2020 Raporu", file: "HASRAPOR2020.pdf" },
  { name: "Bağımsız Güvence Raporu", file: "bagımsızguvencerapor.pdf" },
  { name: "Has Gümüş Borsa Raporu", file: "hasborsauyum.pdf" },
  { name: "Has Gümüş Değerli Madenler Güvence Raporu", file: "hasguvence.pdf" },
  { name: "Has Gümüş Bağımsız Denetim Raporu 2022", file: "hasguvenuyum2023.pdf" },
  { name: "Has Gümüş Değerli Madenler Uyum Raporu", file: "uyumraporu.pdf" },
  { name: "Kıymetli Madenler Sorumlu Tedarik Zinciri Şirket Politikası", file: "KIYMETLI MADEN SORUMLU TEDARIK ZINCIRI POLITIKASI.pdf" },
  { name: "Has Gümüş STZ-2-6", file: "HAS GÜMÜŞ STZ-2-6.pdf" },
  { name: "Has Gümüş Değerli Madenler Yönetim Raporu", file: "hasyonetim.pdf" },
  { name: "Has Gümüş Yönetim Raporu 2023", file: "hasyonetim2023.pdf" },
  { name: "Has Gümüş Yönetim Raporu 2024", file: "Hasgumusyonetim2024.pdf" },
  { name: "Has Gümüş Yönetim Raporu 2025", file: "HAS GÜMÜŞ YÖNETİM RAPORU 2025.pdf" },
  { name: "Has Gümüş Güvence Raporu 2023", file: "hasguvenuyum2023.pdf" },
  { name: "Has Gümüş Güvence Raporu 2024", file: "has_gumus_guvence_raporu_2024.pdf" },
  { name: "Has Gümüş Güvence Raporu 2025", file: "HAS GÜMÜŞ GÜVENCE RAPORU 2025.pdf" },
  { name: "Has Gümüş Bağımsız Denetim Raporu 2023", file: "Hasgumusyonetim2024.pdf" },
  { name: "Has Gümüş Bağımsız Denetim Raporu 2024", file: "has_gumus_bagimsiz_denetim_raporu_2024.pdf" },
  { name: "Has Gümüş Bağımsız Denetim Raporu 2025", file: "HAS GÜMÜŞ BAĞIMSIZ DENETİM RAPORU 2025.pdf" }
];

const Products: React.FC = () => {
  const { t } = useLanguage();
  return (
    <div className="products-container">
      <div className="products-title">{t('products.dokumanlar')}</div>
      <ul className="pdf-list">
        {pdfList.map((item, idx) => (
          <li
            key={item.file}
            className="pdf-list-item"
            style={{ animationDelay: `${idx * 0.08 + 0.1}s` }}
          >
            <a
              href={require(`../assets/has-docs/${item.file}`)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Products;
